import { createColumnHelper } from '@tanstack/react-table';

import { ClusterRoleBinding } from '../types';

export const columnHelper = createColumnHelper<ClusterRoleBinding>();
